import { styled } from '@mui/material';

import { Typography, Divider, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import { MegaphoneIcon, OpenIcon } from '@app-velocity/icons';
import { useAppContext, usePricing } from '@app-velocity/config';

import { Page } from '../../layouts';

const Content = styled('div')(({ theme }) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

const UpgradeHeader = styled(Typography)({
  fontWeight: 600,
  fontSize: 18,
});

const TryDemosText = styled(Typography)({
  fontWeight: 500,
  fontSize: 13,
});

const FreePlanText = styled(Typography)({
  fontSize: 13,
  whiteSpace: 'pre-wrap',
  textAlign: 'center',
});

const IconContainer = styled('div')({
  svg: {
    fill: '#F28511',
  },
});

export const UpgradeNeeded = () => {
  const { t } = useI18n();
  const { AVMLink } = useAppContext();
  const { getPlanPrice } = usePricing();

  const openSpotifyDemo = () => {
    window.open(import.meta.env.VITE_SPOTIFY_ONBOARDING);
  };

  const openNetflixDemo = () => {
    window.open(import.meta.env.VITE_NETFLIX_ONBOARDING);
  };

  const openAppleDemo = () => {
    window.open(import.meta.env.VITE_APPLE_CALENDAR);
  };

  const goToPayments = () => {
    window.open(`${AVMLink}?action=subscription`);
  };

  return (
    <Page>
      <Content>
        <IconContainer>
          <MegaphoneIcon />
        </IconContainer>
        <UpgradeHeader>{t('payments:free_plan_update')}</UpgradeHeader>
        <FreePlanText>{t('payments:free_plan_description_1')}</FreePlanText>
        <FreePlanText>{t('payments:free_plan_description_2')}</FreePlanText>
        <Button fullWidth variant="cta" onClick={goToPayments}>
          {t('payments:upgrade_now', {
            price: getPlanPrice('regular'),
            interpolation: {},
          })}
        </Button>
        <Divider text={t('payments:free_plan_or')} />
        <TryDemosText>{t('payments:use_demos_for_free')}</TryDemosText>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          onClick={openSpotifyDemo}
        >
          {t('prototypes:demos.spotify')}
          <OpenIcon />
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          onClick={openNetflixDemo}
        >
          {t('prototypes:demos.netflix')}
          <OpenIcon />
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          onClick={openAppleDemo}
        >
          {t('prototypes:demos.apple')}
          <OpenIcon />
        </Button>
      </Content>
    </Page>
  );
};
